(ns ycweb.app.admin.stores.storeordertracking
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.common :as cmn]
   [ycweb.util.comms :as comms]
   [ycweb.components.flow :as flow]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.grid :as grid]
   [ycweb.components.datepicker :as datepicker]))

(def order-tracking-table-config
  {:table-name :admin.storeordertracking/table-order-tracking
   :row-id :id
   :data-source
   {:cursor [:admin.storeordertracking :order-tracks]}
   :options
   {:order :desc
    :sort-title "Date Added"
    :sticky-header? true
    :paging? true
    :pagination {:page 0 :page-size 250}}

   :column-defs
   [{:key :supplier-name
     :title "Supplier Name"}
    {:key :storename
     :title "Store Name"}
    {:key :status
     :title "Status"}
    {:key :dateadded
     :type :date
     :dateformat "dd MMM yyyy HH:mm"
     :title "Date Added"}
    {:key :dateprereceived
     :type :date
     :dateformat "dd MMM yyyy HH:mm"
     :title "Date Prereceived"}
    {:key :datereceived
     :type :date
     :dateformat "dd MMM yyyy HH:mm"
     :title "Date Received"}
    {:key :days_pre_to_received
     :title "Days Pre To Received"}
    {:key :order-qty
     :title "Order Qty"}
    {:key :received-qty
     :title "Received Qty"}
    {:key :qty-difference
     :title "Qty Difference"}
    {:key :order-value
     :title "Order Value"}
    {:key :received-value
     :title "Received Value"}
    {:key :value-difference
     :title "Value Difference"}
    {:key :ordernumber
     :title "Order Number"}
    {:key :supplierref
     :title "Supplier Invoice"}
    {:key :link
     :title "Link"
     :render {:render-k :link-fn }}]})

(def store-tracking-table-fns
  {:column-fns
   {:link-fn
    (fn [_ _ _ cell-val]
      [:a
       {:target "_blank"
        :href (str cell-val)}
       "Review Order"])}})

(rum/defc order-tracking < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        warehouses
        (->
          (cmn/curact process-atom :warehouses)
          (conj {:name "All Stores"}))]
    [:<>
     [:div.admin-react-wrapper__content
      (headings/heading "Store YCS Order Tracking" {:type :h1 :size :large})]

     [:div
      [:form.form.u-max-width-640.u-margin-bottom-20
       (datepicker/datepicker app-atom "Date From:" "dd-mm-yyyy"
         [:admin.storeordertracking :date-from]
         {:header "Date From"
          :datatype :datedmy})
       (datepicker/datepicker app-atom "Date To:" "dd-mm-yyyy"
         [:admin.storeordertracking :date-to]
         {:header "Date To" 
          :datatype :datedmy})

       (forms/select "Store"
         (rum/cursor-in process-atom [:warehouse])
         (map
           (fn [warehouse]
             {:value (:id warehouse) :text (:name warehouse)})
           warehouses))]

      (buttons/button-web "Submit"
        {:on-click #(grid/dispatch-action app-atom :admin.storeordertracking/order-tracking-search {})
         :type :button
         :style :primary
         :size :default})]

     [:div
      (datatables/table app-atom
        :admin.storeordertracking/table-order-tracking
        store-tracking-table-fns)
      (toaster/loading-overlay app-atom :admin.stockmovement/order-tracking)]]))

(defmethod comms/receive :admin.storeordertracking/order-tracking [app-atom {:keys [order-tracks]}]
  (toaster/close-overlay app-atom :admin.stockmovement/order-tracking)
  (swap! app-atom update :admin.storeordertracking
    (fn [process]
      (assoc process
        :order-tracks (u/index-by :id order-tracks)))))

(defmethod grid/action :admin.storeordertracking/order-tracking-search [app-atom _ _]
  (toaster/open-overlay app-atom :admin.stockmovement/order-tracking)
  (let [process-atom (cmn/process-cursor app-atom)
        {date-from :date-from
         date-to :date-to
         warehouse :warehouse} @process-atom]
    (comms/send :admin.storeordertracking/order-tracking
      {:date-from date-from
       :date-to date-to
       :warehouse-id warehouse})))

(defmethod comms/receive :admin.storeordertracking/list-all-warehouses [app-atom {:keys [warehouses]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :warehouses warehouses)))

(defmethod t/transition-open :admin.storeordertracking [app-atom _ _]
  (toaster/open-overlay app-atom :admin.stockmovement/list-stock-movements)
  (comms/send :admin.storeordertracking/list-all-warehouses {})
  (datatables/initiate app-atom order-tracking-table-config {}))

(defmethod t/transition-after-open :admin.storeordertracking [app-atom _ _]
  (presence/open app-atom {:context/ident :admin.stockmovement}))

(defmethod flow/render-screen :admin.storeordertracking [app-atom _]
  (order-tracking app-atom))